import { Loading } from "../app/Status";
import { PageHeader } from "../app/PageHeader";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router";
import type { BuildingSummary } from "@klantpunt/shared";
import { api } from "../lib/api";
import { can, useMe } from "../lib/auth";
import { IconChevronRight } from "../app/icons";

/** /melden (meld.pandwachters.nl): gebouw kiezen, daarna direct het formulier "Nieuwe bevinding". */
export function ReportPage() {
  const { data: me } = useMe();
  const navigate = useNavigate();
  const buildings = useQuery({
    queryKey: ["buildings", me?.org?.id],
    queryFn: () => api<BuildingSummary[]>("/buildings"),
  });
  const list = useMemo(() => buildings.data ?? [], [buildings.data]);

  useEffect(() => {
    if (list.length === 1 && can(me, "issue.create")) navigate(`/gebouwen/${list[0]!.id}?nieuw=1`, { replace: true });
  }, [list, me, navigate]);

  return (
    <div className="page narrow">
      <PageHeader label="Melden" title="Nieuwe bevinding" />
      {!can(me, "issue.create") ? (
        <div className="panel">
          <p className="muted">Je hebt geen rechten om bevindingen vast te leggen.</p>
        </div>
      ) : (
        <section className="panel" aria-busy={buildings.isPending}>
          <p className="muted">In welk gebouw?</p>
          {buildings.isPending ? (
            <Loading />
          ) : list.length ? (
            <ul className="list">
              {list.map((b) => (
                <li key={b.id}>
                  <Link to={`/gebouwen/${b.id}?nieuw=1`} className="buildinglink">
                    <span className="code">{b.code}</span>
                    <span className="grow">
                      <strong>{b.name}</strong>
                      {b.address && <span className="muted addr">{b.address}</span>}
                    </span>
                    <IconChevronRight size={20} aria-hidden="true" className="muted" />
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <p className="muted">Nog geen gebouwen.</p>
          )}
        </section>
      )}
    </div>
  );
}
